/**
 * Mega menu controller (Razor-rendered DOM)
 * Usage:
 *   import { initMegaMenu } from "./mega-menu";
 *   const megaMenu = initMegaMenu({ debug: false });
 *   // optional: megaMenu.destroy();
 */
export function initMegaMenu(options = {}) {

    const Collapse = window.bootstrap.Collapse;

    const settings = {
        menuOpenClass: "menu-open",
        debug: false,
        mainMenuId: "MainMenu",
        mobileBreakpointPx: 767,
        ...options,
    };

    let initialized = false;

    function log(message, obj) {
        if (!settings.debug) return;

        if (message !== "" && obj !== null && obj !== undefined) console.log(message, obj);
        else console.log(message);
    }

    function closeMenu() {
        const menu = document.getElementById("MainMenu");

        // Always close the Bootstrap collapse if it's open
        if (menu && menu.classList.contains("show")) {
            Collapse.getOrCreateInstance(menu).hide();
        }

        // Then clear your custom state
        if ($("body").hasClass(settings.menuOpenClass)) {
            $("body").removeClass(settings.menuOpenClass);
            $(".navbar-left > li").removeClass("active");
        }

        log("mega-menu closeMenu");
    }

    // --- event handlers ---
    function onNavbarTogglerClick() {
        log("mega-menu toggle click");
        //$("body").toggleClass(settings.menuOpenClass);
        if ($("body").hasClass(settings.menuOpenClass)) {
            $("body").removeClass(settings.menuOpenClass);
        } else {
            $("body").addClass(settings.menuOpenClass);
        }
    }

    function onBtnCloseMenuClick(e) {
        log("mega-menu btn-close-menu click");
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
    }

    function onOverlayCloseMenuClick() {
        closeMenu();
    }

    function onNavLinkAnchorClick(e) {
        e.stopPropagation();
        log("click nav-link > a");
    }

    function onNavbarSecondaryNavItemClick(e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(this);
        const closeItem = $this.hasClass("active");

        log("click navbar-secondary, nav-item > a");

        if (!$("body").hasClass(settings.menuOpenClass)) {
            $("body").addClass(settings.menuOpenClass);
        }

        $(".navbar-secondary .nav-item").removeClass("active");

        if (!closeItem) {
            $this.addClass("active");
            $("body").attr("data-menu-name", $this.data("menu-name"));
        } else {
            if (window.innerWidth > settings.mobileBreakpointPx) {
                $("body").removeClass(settings.menuOpenClass);
            }
        }
    }

    function onMegaMenuBackgroundClick() {
        closeMenu();
        log("click .nav-links or .mega-menu-background");
    }

    function onOverlayCloseMenuClickTouch() {
        closeMenu();
        log("click or touchstart of close menu");
    }

    function onPreventHashLinksClick(e) {
        e.preventDefault();
    }

    function onEscapeKeyDown(e) {
        if (e.key !== "Escape") return;

        const menu = document.getElementById(settings.mainMenuId);
        const isOpen =
            document.body.classList.contains(settings.menuOpenClass) ||
            (menu?.classList.contains("show"));

        if (!isOpen) return;

        // Close Bootstrap collapse (triggers hidden.bs.collapse)
        if (menu && menu.classList.contains("show")) {
            Collapse.getOrCreateInstance(menu).hide();
        }

        // Also close your custom overlay/menu state immediately
        closeMenu();
    }

    function init() {
        if (initialized) return;
        initialized = true;

        // jQuery delegated handlers
        $(document).on("click", ".port-navbar .navbar-toggler", onNavbarTogglerClick);
        $(document).on("click", ".btn-close-menu", onBtnCloseMenuClick);
        $(document).on("click", "body.menu-open .menu-overlay > .close-menu", onOverlayCloseMenuClick);
        $(document).on("click", ".nav-link > a", onNavLinkAnchorClick);
        $(document).on("click", ".navbar-secondary .nav-item", onNavbarSecondaryNavItemClick);
        $(document).on("click", ".mega-menu-background", onMegaMenuBackgroundClick);

        $(document).on("click touchstart", ".menu-overlay > .close-menu", onOverlayCloseMenuClickTouch);

        $(document).on(
            "click",
            ".port-navbar a[href='#'], .port-navbar a[href='#/'], .mega-menu a[href='#'], .mega-menu a[href='#/']",
            onPreventHashLinksClick
        );

        // Native key handler (modern, not deprecated)
        document.addEventListener("keydown", onEscapeKeyDown);

        log("mega-menu init complete");
    }

    function destroy() {
        if (!initialized) return;
        initialized = false;

        // Remove delegated handlers
        $(document).off("click", ".port-navbar .navbar-toggler", onNavbarTogglerClick);
        $(document).off("click", ".btn-close-menu", onBtnCloseMenuClick);
        $(document).off("click", "body.menu-open .menu-overlay > .close-menu", onOverlayCloseMenuClick);
        $(document).off("click", ".nav-link > a", onNavLinkAnchorClick);
        $(document).off("click", ".navbar-secondary .nav-item", onNavbarSecondaryNavItemClick);
        $(document).off("click", ".mega-menu-background", onMegaMenuBackgroundClick);

        $(document).off("click touchstart", ".menu-overlay > .close-menu", onOverlayCloseMenuClickTouch);

        $(document).off(
            "click",
            ".port-navbar a[href='#'], .port-navbar a[href='#/'], .mega-menu a[href='#'], .mega-menu a[href='#/']",
            onPreventHashLinksClick
        );

        document.removeEventListener("keydown", onEscapeKeyDown);

        log("mega-menu destroyed");
    }

    // auto-init unless you prefer manual
    init();

    return {
        init,
        destroy,
        closeMenu,
        setDebug(debug) {
            settings.debug = !!debug;
        },
    };
}
